import React, { useState, useEffect, useRef } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";

interface PasswordInputProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    name?: string;
    placeholder?: string;
    className?: string;
    readOnly?: boolean;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
    value,
    onChange,
    name = "password",
    placeholder = "Enter password",
    className = "",
    readOnly = false
}) => {
    const [visible, setVisible] = useState(false);
    const autoHideTimer = useRef<NodeJS.Timeout | null>(null);
    const userClickedHide = useRef(false);

    const toggleVisibility = () => {
        if (visible) {
            userClickedHide.current = true;
            setVisible(false);
        } else {
            userClickedHide.current = false;
            setVisible(true);
        }
    };

    useEffect(() => {
        if (visible && !userClickedHide.current && !readOnly) {
            if (autoHideTimer.current) clearTimeout(autoHideTimer.current);
            autoHideTimer.current = setTimeout(() => {
                setVisible(false);
            }, 5000);
        }

        return () => {
            if (autoHideTimer.current) clearTimeout(autoHideTimer.current);
        };
    }, [visible, readOnly]);

    return (
        <div className={`input-group ${className}`}>
            <input
                type={visible ? "text" : "password"}
                className="form-control"
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                readOnly={readOnly}
                autoComplete="new-password"
            />
            <input type="password" style={{ display: 'none' }} name="fakepasswordremembered" />
            <button
                type="button"
                className="btn btn-outline-secondary border"
                onClick={toggleVisibility}
                tabIndex={-1}
            >
                {visible ? <BsEyeSlash size={18} /> : <BsEye size={18} />}
            </button>
        </div>
    );
};

export default PasswordInput;
